import React from 'react';
import {Appbar} from 'react-native-paper';
import {
  FolderParams,
  ProjectParams,
  RootScreens,
  RootStackName,
  RootStackRouteNames,
  StackRouteName,
  UnifiedStackParams,
} from '../../../types/nav';
import {useAppSelector} from '../../../store/hooks';
import {Folder} from '../../../types';
import {
  NavigationProp,
  useNavigation,
} from '@react-navigation/native';

export function BackButton({folder}: {folder: Folder | undefined}) {
  const navigation =
    useNavigation<NavigationProp<UnifiedStackParams>>();
  const params = useAppSelector(state => state.ui.params);
  const routeName = useAppSelector(state => state.ui.currentPage);
  const parentName = useAppSelector(state => state.ui.parentName);
  const folderId = (params as FolderParams)?.folderId;
  const parentFolderId =
    (params as ProjectParams)?.parentFolderId ||
    (folder?.folderId as string);
  const backPress = () => {
    // console.info('backpress')
    let backRoute = RootScreens[parentName];
    const folderParams: FolderParams = {
      folderId: parentFolderId,
      mnemonic:
        parentFolderId?.search('new_') === -1
          ? folder?.mnemonic
          : undefined,
      title: folder?.title as string,
    };
    if (parentName == 'ShopTab') {
      backRoute = 'Shops';
    }
    if (routeName === 'Camera' && params?.chatId) {
      navigation.navigate(RootStackName, {
        screen: parentName,
        params: {
          screen: 'Chat',
          params,
        },
      });
      return;
    }

    console.info({folderParams});
    if (folderParams.folderId && folderParams.folderId !== folderId) {
      navigation.navigate(RootStackName, {
        screen: parentName,
        params: {
          screen: 'Folder',
          params: folderParams || params,
        },
      });
      return;
    }

    navigation.navigate(RootStackName, {
      screen: parentName,
      params: {
        screen: backRoute,
        params: undefined,
      },
    });
  };
  return (
    <Appbar.Action
      style={{zIndex: 100}}
      icon="chevron-left"
      onPress={backPress}
    />
  );
}
